import React, { useState, useEffect } from 'react';
import { Nav, Row, Col, Tab } from 'react-bootstrap';
import styled from 'styled-components';
import { FaShoppingCart } from 'react-icons/fa';
import { ImTree } from 'react-icons/im';
import { RiSettings5Fill } from 'react-icons/ri';
import { SiHomeassistantcommunitystore } from 'react-icons/si';
import BuysReportTab from './buys-report-tab';
import DistributeReportTab from './distribute-report-tab';
import ProductReportTab from './product-report-tab';
import StoreReportTab from './store-report-tab';
import { HDivider } from 'components/CommonWidgets';
import { useAdminDispatch } from 'admin-app/redux/admin.store';
import { resetAllFilters } from 'admin-app/redux/reporting-filter.slice';

const MainCard = styled.div`
	background-color: white;
	position: relative;
	border-radius: 26px;
	margin: 1rem 0 0 1rem;
`;

const TabsCard = styled.div`
	background-color: white;
	margin: 0 auto;
	border-radius: 26px;
`;

const TabColumn = styled(Col)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    a {
        color: black;
        font-weight: 900;
        font-size: 14pt;
    }
`;

const TabLine = styled.div`
	width: 10em;
	height: 0.5rem;
	background-color: #0278ee;
	border-top-left-radius: 11px;
	border-top-right-radius: 11px;
`;

const TabContent = styled(Tab.Content)`
    width: 100%;
    margin: 2rem 0 3rem 0;
    transition: all 500ms ease-in-out;
`;

const PageTitle = styled.div`
	color: white;
	font-size: 18pt;
	font-weight: 700;
	text-align: end;
`;

const Reporting = () => {
	const [currentTab, setCurrentTab] = useState('buy-report');
	const dispatch = useAdminDispatch();

	const onTabChange = newTab => {
		dispatch(resetAllFilters());
		setCurrentTab(newTab);
	};

	useEffect(() => {
		dispatch(resetAllFilters());
	}, []);

	return (
		<div>
			<Row className="mt-2">
				<PageTitle>گزارش گیری</PageTitle>
			</Row>
			<MainCard>
				<Tab.Container defaultActiveKey={currentTab} onSelect={onTabChange}>
					<TabsCard className="pt-4">
						<Nav>
							<Row className="w-100">
								<TabColumn md={3}>
									<SiHomeassistantcommunitystore size={26} />
									<Nav.Item>
										<Nav.Link className='text-center' eventKey={'store-report'}>گزارش انبار</Nav.Link>
									</Nav.Item>
									{currentTab === 'store-report' && <TabLine />}
								</TabColumn>
								<TabColumn md={3}>
									<RiSettings5Fill size={26} />
									<Nav.Item>
										<Nav.Link className='text-center' eventKey={'product-report'}>گزارش تولید</Nav.Link>
									</Nav.Item>
									{currentTab === 'product-report' && <TabLine />}
								</TabColumn>
								<TabColumn md={3}>
									<ImTree size={26} />
									<Nav.Item>
										<Nav.Link className='text-center' eventKey={'distribute-report'}>گزارش توزیع</Nav.Link>
									</Nav.Item>
									{currentTab === 'distribute-report' && <TabLine />}
								</TabColumn>
								<TabColumn md={3}>
									<FaShoppingCart size={26} />
									<Nav.Item>
										<Nav.Link className='text-center' eventKey={'buy-report'}>گزارش خرید</Nav.Link>
									</Nav.Item>
									{currentTab === 'buy-report' && <TabLine />}
								</TabColumn>
							</Row>
							<HDivider />
						</Nav>
					</TabsCard>
					<Row>
						<TabContent>
							<Tab.Pane eventKey="buy-report">
								<BuysReportTab currentTab={currentTab} />
							</Tab.Pane>
							<Tab.Pane eventKey="distribute-report">
								<DistributeReportTab currentTab={currentTab} />
							</Tab.Pane>
							<Tab.Pane eventKey="product-report">
								<ProductReportTab currentTab={currentTab} />
							</Tab.Pane>
							<Tab.Pane eventKey="store-report">
								<StoreReportTab currentTab={currentTab} />
							</Tab.Pane>
						</TabContent>
					</Row>
				</Tab.Container>
			</MainCard>
		</div>
	);
};

export default Reporting;
